
<hp-slider  [urlWownet]="urlWownet" [showMainProd]="true"></hp-slider>
<board-popup></board-popup>
<!-- <hp-features  [urlWownet]="urlWownet" [lshowPdtYn] = "lshowPdtYn"></hp-features> -->
<!-- <hp-media [urlWownet]="urlWownet"></hp-media> -->
<!-- mainBrand -->
 <hp-brand></hp-brand>
 <hp-notice [showMainTen]="false"></hp-notice>
<!-- //mainBrand -->
<!-- mainStore -->
<div class="mainStore">
    <div class="contain">
        <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
            <p>The jogak Plus System</p>
            더조각 플러스 시스템 도입 지점
        </h2>
        <div class="mainStoreCont" data-aos="fade-down" data-aos-delay="400" data-aos-duration="800" style="height: 650px;">
            <app-plus-map></app-plus-map>
        </div>
    </div>
</div>
<!-- //mainStore -->

<!-- mainSeminar -->
<div class="mainSeminar">
    <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
        <p>The jogak Plus System</p>
        새로운 사업의 성공스토리를 만들어가실 <i></i>대표님들을 모십니다.  
    </h2>
    <p data-aos="fade-down" data-aos-delay="300" data-aos-duration="800">
        더조각 플러스 시스템 도입 신청은 선착순이 아닙니다. <i></i>
        최대한 정보를충분히 검토하고, 신중히판단 하세요. <i></i>
        저희 시스템이 도움이 된다고 확신이 되는 분에 한해 진행해드립니다.
    </p>
    <div class="btns" data-aos="fade-down" data-aos-delay="400" data-aos-duration="800">
        <a class="btn-seminar" href="https://forms.gle/yHVUoKqiZ4okFybH6" target="_blank">세미나 일정 보기 및 접수신청</a>
        <a class="btn-kakao" href="https://pf.kakao.com/_xnSsxcxj/chat" target="_blank">카카오톡 문의하기</a>
    </div>
</div>
<!-- //mainSeminar -->

<!-- <hp-register></hp-register> -->

<!-- <hp-notice [urlWownet]="urlWownet"></hp-notice> -->
